<template>
  <LazyHero
    :height-auto="blok.heightAuto"
    :align-center="blok.alignCenter"
    :no-overlay="blok.noOverlay"
    :title-length="title.length"
    :longest-word="longestWord">
    <template #background>
      <StoryblokComponent v-for="blokBody in blok.background" :key="blokBody._uid +'bg'" :blok="blokBody" />
    </template>
    <StoryblokComponent v-for="blokBody in blok.content" :key="blokBody._uid +'content'" :blok="blokBody" />

    <template #actions>
      <StoryblokComponent v-for="blokBody in blok.actions" :key="blokBody._uid +'actions'" :blok="blokBody" />
    </template>
  </LazyHero>
</template>
<script setup>
const props = defineProps({ blok: Object })

// The first heading in the hero text, so the hero can size it to fit
const title = computed(() => {
  const text = node => node?.text ?? (node?.content ?? []).map(text).join('')
  for (const block of props.blok.content ?? []) {
    const heading = block.text?.content?.find(node => node.type === 'heading')
    if (heading) return text(heading).trim()
  }
  return ''
})
const longestWord = computed(() => Math.max(0, ...title.value.split(/\s+/).map(word => word.length)))
</script>
